export default __webpack_public_path__ + "static/media/49-SituStudio.171e0a05.jpg";